import React from 'react';

const Step5Infos = (props) => {
    return (
        <div className="slc-wizard-infos-step slc-wizard-infos-step-5">
        Consoscere il tipo di tegola o di copertura ci permette di valutare sin da subito la struttura di supporto da utilizzare per l'installazione dell'impianto fotovoltaico.<br />
        Nel caso non lo sapessi, questa informazione sarà raccolta in fase di sopralluogo.
        </div>
    );
}

export default Step5Infos;